<template>
  <div class="modal-mask">
    <div class="modal-wrapper">
      <div class="modal-container">
        <img
          src="../assets/Cross_Symbol_big.svg"
          class="close-icon"
          @click="$emit('close')"
        />
        <div class="heading">System compatibility check</div>
        <div class="horizontal-line"></div>
        <div>
          <img src="../assets/System_incp.svg" class="image" />
        </div>
        <div class="horizontal-line"></div>
        <div class="system-compatibilty">
          <div class="cross-symbol">
            <img src="../assets/Cross_Symbol.svg" />
          </div>
          <div v-if="!timeMismatch" class="system-compatibilty-msg">
            Please use a laptop/ desktop for taking the test!
          </div>
          <div v-if="timeMismatch" class="system-compatibilty-msg">
            System is not compatible for the test because your system time does
            not match with server time
          </div>
        </div>
        <div class="horizontal-line"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Modal',
  props: ['timeMismatch'],
}
</script>

<style scoped>
.close-icon {
  float: right;
  margin-top: -13px;
  margin-right: -8px;
}

.heading {
  margin: 16px auto 16px 33px;
  font-family: Roboto-Light;
  font-size: 24px;
  color: #616262;
  letter-spacing: 0;
  text-align: left;
}

.horizontal-line {
  border: 0.5px solid #d9d9d9;
}

.image {
  margin: 24px 76px;
}

.system-compatibilty {
  display: flex;
  padding: 25px 65px;
  background: rgba(246, 105, 87, 0.1);
}

.cross-symbol {
  margin-right: 16px;
  text-align: left;
}

.system-compatibilty-msg {
  font-family: Roboto-Regular;
  font-size: 14px;
  color: #f66957;
  letter-spacing: 0;
}

.browser-property-div {
  display: flex;
  margin: 24px auto 24px 30px;
}

.browser-property {
  font-family: Roboto-Medium;
  font-size: 14px;
  color: #616262;
  letter-spacing: 0;
  width: 112px;
  text-align: left;
}

.modal-mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #000000;
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  background: #ffffff;
  border: 1px solid #d9d9d9;
  box-shadow: 0 3px 0 0 rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  width: 400px;
  margin: auto;
}

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>
